import {
  Button,
  ButtonColor,
  Icon,
  IconName,
  IconSize,
  IconVariant,
  Tooltip
} from "@quortex/front-common"
import type { FC } from "react"
import type { AddOttEndpointModalGenerics } from "@/App/play/components/wired/modals/AddOttEndpointModal"
import type { OttEndpointRow } from "./types"

interface Props {
  row: OttEndpointRow
}

const AddOttEndpointButton: FC<Props> = ({ row }) => (
  // biome-ignore lint/a11y/useKeyWithClickEvents: -
  // biome-ignore lint/a11y/noStaticElementInteractions: -
  <div
    onClick={e => {
      e.stopPropagation() /* Disabled button would not handle click event */
    }}
  >
    <Tooltip
      body="All possible endpoints for this input already exist"
      enabled={!row.canAddOttEndpoint}
    >
      <Button
        color={ButtonColor.PRIMARY}
        data-testid="add-ott-endpoint-btn"
        disabled={!row.canAddOttEndpoint}
        to={{
          search: old => ({
            ...old,
            ...({
              modal: { inputUuid: row.inputUuid, name: "add_ott_endpoint" }
            } as AddOttEndpointModalGenerics["Search"])
          })
        }}
        type="link"
      >
        <Icon icon={IconName.PLUS} size={IconSize.MEDIUM} type={IconVariant.SOLID} />
        Add an endpoint
      </Button>
    </Tooltip>
  </div>
)

export default AddOttEndpointButton
